// The sign-in methods shown on the entry screen (FR-001, FR-011; P-AUTH-4; constitution VI).
// 002: email + password only. Google and phone + OTP later are one entry each, all ending in the
// session controller's completeSignIn (FR-002). No control for an unavailable method (FR-003).
import { emailPasswordMethod } from "@/auth/email/EmailPasswordEntry";

import type { SignInMethod } from "./types";

export const signInMethods: readonly SignInMethod[] = [emailPasswordMethod];
